import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { colors,theme } from '../../components/theme';

export const LoginFormDocPlace = styled.form`
    width: 100%;
    min-height: 300px;
    margin-top: 0%;
    padding: 20px 12px 12px 8px;
    background-color: ${colors.white};
`;

export const WrapperFormDocPlace = styled.section`
    margin: 0px 25px 0px 25px;
    position: relative;
`;

export const SingInDocPlace = styled.div`
      font-size: 1.3rem;
      color: ${colors.blue};
      margin: 0px 0px 27px 0;
      text-decoration: underline;
      text-align: left;
`;

export const Wrapper = styled.div`
    width: 100%;
    height: 100vh;
    background-color: ${colors.white };
    background-image:url(${theme.bg});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: left;
`;

export const WrapperLogin = styled.div`
    width: 400px;
    height: 100%;
    background-color: ${colors.white};
    float: right;
    overflow-y: auto;
    overflow-x: hidden;
    display: block;
    max-width: 400px;
    box-shadow: -2px 0px 20px rgba(0, 0, 0, 0.15);
`;

export const ForgetPassword = styled.div`
      height: 10px;
      color: #607d8b;
      font-size: 11px;
      margin: 12px auto;
      width: 100%;
      text-align: center;
      text-decoration: underline;
      cursor: pointer;
`;

export const SecurityHeader = styled.div`
    display: flex;
    align-items: center;
    padding: 20px 25px 15px 25px;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    border-bottom: 3px solid ${colors.green};
    margin-bottom: 10px;

    div {
        flex: 1;
    }
`;

export const SecurityBadge = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 8px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    margin: 15px 0;
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);

    span {
        display: flex;
        align-items: center;
    }
`;

export const PasswordRequirementsList = styled.div`
    background: #f8f9fa;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 15px;
    margin: 15px 0;
    font-size: 13px;
`;

export const PasswordRequirement = styled.div`
    display: flex;
    align-items: center;
    margin: 8px 0;
    color: ${props => props.met ? colors.green : colors.gray};
    font-weight: ${props => props.met ? '600' : '400'};
    transition: all 0.3s ease;

    .icon-met {
        color: ${colors.green};
        font-size: 18px;
        margin-right: 8px;
    }

    .icon-not-met {
        color: #ccc;
        font-size: 18px;
        margin-right: 8px;
    }
`;

export const PasswordStrengthMeter = styled.div`
    margin: 15px 0;

    .strength-bar {
        width: 100%;
        height: 8px;
        background: #e0e0e0;
        border-radius: 10px;
        overflow: hidden;
        margin-bottom: 5px;
    }

    .strength-fill {
        height: 100%;
        transition: width 0.3s ease, background-color 0.3s ease;
        border-radius: 10px;
    }

    .strength-label {
        font-size: 12px;
        color: ${colors.gray};

        strong {
            color: ${props => props.strengthColor};
        }
    }
`;

export const PasswordMatchIndicator = styled.div`
    display: flex;
    align-items: center;
    margin: 10px 0 15px 0;
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 600;
    background: ${props => props.matched ? '#e8f5e9' : '#ffebee'};
    color: ${props => props.matched ? colors.green : colors.red};

    .icon-matched {
        color: ${colors.green};
        font-size: 20px;
        margin-right: 8px;
    }

    .icon-not-matched {
        color: ${colors.red};
        font-size: 20px;
        margin-right: 8px;
    }
`;





export const useStyles = makeStyles((theme) => ({
    buttons: {
        width: '100%',
        display: 'inline-block',
        marginTop: '20px',
        height: '45px',
        backgroundColor: "#119949 !important",
        color: '#fff !important',
        fontSize: '15px !important',
        fontWeight: '600 !important',
        boxShadow: '0 4px 12px rgba(17, 153, 73, 0.3) !important',
        transition: 'all 0.3s ease !important',
        '&:hover': {
            backgroundColor: "#037432 !important",
            boxShadow: '0 6px 16px rgba(17, 153, 73, 0.4) !important',
        },
        '&:disabled': {
            backgroundColor: '#ccc !important',
            boxShadow: 'none !important',
        }
    },
    imgLogo: {
        width: '100%',
        height: '120px',
        objectFit: 'contain',
        margin: '30px 0px 0px 0px',
        cursor: 'pointer'
    },
    securityIcon: {
        fontSize: '40px !important',
        color: colors.green,
        marginRight: '15px',
        filter: 'drop-shadow(0 2px 4px rgba(17, 153, 73, 0.3))'
    },
    securityTitle: {
        fontSize: '18px',
        fontWeight: '700',
        color: colors.gray2,
        margin: '0 0 5px 0',
        lineHeight: '1.2'
    },
    securitySubtitle: {
        fontSize: '12px',
        color: colors.gray,
        margin: '0',
        lineHeight: '1.3'
    },
    requirementsTitle: {
        display: 'flex',
        alignItems: 'center',
        fontWeight: '600',
        color: colors.gray2,
        marginBottom: '10px',
        fontSize: '13px'
    }
}));


  



